import { useEffect } from 'react';

export default function PageSEO({ title, description, keywords }) {
  useEffect(() => {
    document.title = title ? `${title} | OmniView` : 'OmniView — Marketing Intelligence Platform';
    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`) || document.querySelector(`meta[property="${name}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute(name.startsWith('og:') ? 'property' : 'name', name); document.head.appendChild(el); }
      el.setAttribute('content', content);
    };
    if (description) {
      setMeta('description', description);
      setMeta('og:description', description);
      setMeta('twitter:description', description);
    }
    if (keywords) setMeta('keywords', keywords);
    if (title) {
      setMeta('og:title', `${title} | OmniView`);
      setMeta('twitter:title', `${title} | OmniView`);
    }
  }, [title, description, keywords]);
  return null;
}
